import {LoadingSpinner} from "../elements/index.js";
import JSX from "../../helpers/react.js";
import RefObject = JSX.RefObject;
import {ServerApi} from "../../api.js";
import {askQuestion, handleFetchError, showAskDialog, YummyServerError} from "../../helpers/functions.js";
import {IOneAppJson} from "../../../../../nodeserver/structs/database.js";
import {showNotice} from "../../helpers/functions.js";
import {AddNewAppDialog} from "./AddNewAppDialog.js";
import {StatisticsPage} from "./statistics/StatisticsPage.js";

export function OneDevAppPage({id}: { id: number }) {
    const element: RefObject<HTMLDivElement> = {};
    const elementStat: RefObject<HTMLDivElement> = {};
    setTimeout(() => loadData(element, id));
    return (
        <div className="tabs-block">
            <div className="tabs-header">
                <ul className="tabs">
                    <li data-id="#app-data" className="tabs-li active materiable">
                        <i className="fa fa-info"/> Информация
                    </li>
                    <li data-id="#app-stat" className="tabs-li materiable" onClick={() => loadStatisticsPage(elementStat, id)}>
                        <i className="fa fa-hourglass-start"/> Статистика
                    </li>
                </ul>
            </div>
            <div className="tabs-content">
                <div id="app-data" className="tab-content active" ref={element}/>
                <div id="app-stat" className="tab-content" ref={elementStat}/>
            </div>
        </div>
    )
}

function loadStatisticsPage(refElement: RefObject<HTMLDivElement>, appId: number) {
    if(refElement.value!.childElementCount !== 0) return;
    refElement.value!.appendChild(<StatisticsPage appId={appId}/> as Node);
}

async function loadData(element: RefObject<HTMLDivElement>, id: number) {
    element.value!.innerText = '';
    element.value!.appendChild(<LoadingSpinner large={true}/>);
    try {
        const app = await ServerApi.apps.getAppById(id);
        element.value!.innerText = '';
        element.value!.appendChild(<OneDevApp app={app}/>)
    } catch (e) {
        handleFetchError(e);
        element.value!.innerText = '';
        element.value!.appendChild(<Error retry={() => loadData(element, id)}/>)
    }
}

function Error({retry}: { retry: () => any }) {
    return (
        <div className="center">
            Произошла неизвестная ошибка. <br/>
            <button className="main-button bordered" onClick={retry}>Попробовать ещё раз</button>
        </div>
    )
}


function OneDevApp({app}: { app: IOneAppJson }) {
    return (
        <div>
            <h1>{app.name} <span style={{float: "right", fontSize: "15px"}}>Создано: <local-time
                data-time={app.created_at}/></span></h1>
            <p>{app.description}</p>
            <p><br/></p>
            <p><b>Публичный токен</b> (Посылать в <i>X-Application</i> header): <TextValue value={app.public_token}/>
            </p>
            <br/>
            <p><b>Приватный токен</b>: <TextValue value={app.private_access_token}/></p>
            <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                <button className="main-button bordered" onClick={editApp}>Редактировать</button>
                <button className="main-button bordered attention" style={{marginLeft: "10px"}}
                        onClick={deleteApp}>Удалить
                </button>
            </div>
        </div>
    );

    function editApp() {
        document.body.appendChild(<AddNewAppDialog appID={app.app_id} title={app.name} desc={app.description!}/>)
    }

    async function deleteApp() {
        try {
            if (await showAskDialog('Удалить приложение?',
                <>Вы уверены, что хотите удалить приложение?<br/>
                    Отменить это действие будет невозможно. Все данные, связанные с этим приложением, будут
                    удалены.<br/><br/> Вы уверены, что хотите продолжить?
                </>)) {
                await ServerApi.apps.deleteApp(app.app_id);
                showNotice('Приложение успешно удалено');
                window.location.href = '/dev/applications';
            }
        } catch (e) {
            handleFetchError(e);
        }

    }
}

function TextValue({value}: { value: string }) {
    return (
        <input className="text-value bordered disabled" type="text" value={value}
               style={{width: "300px", float: "right"}}
               onClick={() => {
                   navigator.clipboard.writeText(value);
                   showNotice('Скопировано в буфер обмена');
               }}
        />
    )
}
